const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { createItemSearchSchema } from '@/common/zod-schemas/createItemSearchSchema';
export const Route = createFileRoute('/(app)/org/$org')({
  validateSearch: zodValidator(createItemSearchSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: ({
    context
  }) => context
});